import * as fromDatatype from "../datatype-library/index";

export interface bl_fi_fixed_asset_depreciation_schedule_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  far_hdr_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  depr_start: fromDatatype.TimestampTzDatatypeInterface;
  depr_end: fromDatatype.TimestampTzDatatypeInterface;
  depr_expense: fromDatatype.NumericDatatypeInterface;
  depr_accum: fromDatatype.NumericDatatypeInterface;
  netbook_balance_value: fromDatatype.NumericDatatypeInterface;
  fixed_asset_status: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_fi_fixed_asset_depreciation_schedule_RowClass implements bl_fi_fixed_asset_depreciation_schedule_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  far_hdr_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  depr_start: fromDatatype.TimestampTzDatatypeInterface;
  depr_end: fromDatatype.TimestampTzDatatypeInterface;
  depr_expense: fromDatatype.NumericDatatypeInterface;
  depr_accum: fromDatatype.NumericDatatypeInterface;
  netbook_balance_value: fromDatatype.NumericDatatypeInterface;
  fixed_asset_status: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}
